// (function() {
//     const toggleHeadingElements = document.getElementsByClassName("kg-toggle-heading");

//     const toggleFn = function(event) {
//         const targetElement = event.target;
//         const parentElement = targetElement.closest('.kg-toggle-card');
//         var toggleState = parentElement.getAttribute("data-kg-toggle-state");
//         if (toggleState === 'close') {
//             parentElement.setAttribute('data-kg-toggle-state', 'open');
//         } else {
//             parentElement.setAttribute('data-kg-toggle-state', 'close');
//         }
//     };

//     for (let i = 0; i < toggleHeadingElements.length; i++) {
//         toggleHeadingElements[i].addEventListener('click', toggleFn, false);
//     }
// })();


(function() {
    const hiwBtns = document.querySelectorAll('.hiw-btn');

    hiwBtns.forEach(function(hiwBtn) {
        const hiwCardVisual = hiwBtn.closest('.hiw-card').querySelector('.hiw-card-visual');
        const featuresListContent = hiwBtn.closest('.hiw-card').querySelector('.features-list-content');
        const featuresListSteps = hiwBtn.closest('.hiw-card').querySelector('.reporting-steps');


        // Add a click event listener to the button
        hiwBtn.addEventListener('click', function () {
            // Toggle the visibility of hiw-card-visual and features-list-content
            hiwCardVisual.classList.toggle('hidden');
            featuresListContent.classList.toggle('hidden');
            featuresListSteps.classList.toggle('hidden');
            hiwBtn.classList.toggle('rotate');
        });
    });
})();


(function () {
    // Accordion Functionality
    document.querySelectorAll('.accordian-title').forEach(function (title) {
        title.addEventListener('click', function (e) {
            e.stopPropagation();
            
            const parent = this.parentElement;
            const content = parent.querySelector('.accordian-content');
            
            // Toggle active class and inline styles for the current accordion
            parent.classList.toggle('active');
            if (parent.classList.contains('active')) {
                content.style.display = 'block'; // Set display to block
                content.style.maxHeight = content.scrollHeight + "px"; // Open accordion
            } else {
                content.style.maxHeight = null; // Reset maxHeight
                content.style.display = 'none'; // Set display to none
            }
            
            // Close siblings' accordions
            const siblings = Array.from(parent.parentElement.children).filter(el => el !== parent);
            siblings.forEach(function (sibling) {
                sibling.classList.remove('active');
                const siblingContent = sibling.querySelector('.accordian-content');
                if (siblingContent) {
                    siblingContent.style.maxHeight = null; // Reset maxHeight
                    siblingContent.style.display = 'none'; // Set display to none
                }
            });
        });
    });

    // Smooth Scroll Functionality
    document.querySelectorAll('.scroll-item').forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            const id = this.getAttribute('href');
            const target = document.querySelector(id);

            if (target) {
                window.scrollTo({
                    top: target.offsetTop,
                    behavior: 'smooth' // Smooth scrolling
                });
            }
        });
    });
})();




